import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  DialogContentText,
} from '@mui/material'
import type { ButtonProps, SxProps, Theme } from '@mui/material'

const styles = {
  dialogAction: {
    padding: '8px 16px 16px',
  },
} satisfies Record<string, SxProps<Theme>>

// アクセシブルネームを必ず持たせるため、title か ariaLabel の少なくとも一方を必須にする。
// title があれば DialogTitle が名前になり、無い場合は ariaLabel を role=dialog に付与する。
type Props = {
  isOpen: boolean
  contentText?: string
  contentTextSx?: SxProps<Theme>
  buttonName?: string
  buttonVariant?: ButtonProps['variant']
  onOk: () => void
} & (
  | { title: string; ariaLabel?: string }
  | { title?: string; ariaLabel: string }
)

export function NormalMessageDialog({
  isOpen,
  title,
  ariaLabel,
  contentText,
  contentTextSx,
  buttonName = 'OK',
  buttonVariant,
  onOk,
}: Props) {
  return (
    <Dialog
      fullWidth
      open={isOpen}
      PaperProps={ariaLabel ? { 'aria-label': ariaLabel } : undefined}
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      {contentText && (
        <DialogContent>
          <DialogContentText sx={contentTextSx}>
            {contentText}
          </DialogContentText>
        </DialogContent>
      )}
      <DialogActions sx={styles.dialogAction}>
        <Button onClick={onOk} size="large" variant={buttonVariant}>
          {buttonName}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
